import { Button } from '@vfs-digital-channels/ns-react-components';
import React, { MouseEventHandler } from 'react';

type Props = {
  title: string;
  description: string;
  buttonTitle: string;
  onButtonPress: MouseEventHandler<HTMLButtonElement>;
};

export function BCACard({ title, description, buttonTitle, onButtonPress }: Props) {
  return (
    <article className="flex flex-col gap-6 px-6 py-4 my-8 bg-grey-900">
      <header className="flex flex-col gap-4">
        <h3 className="text-4xl">{title}</h3>
        <p className="text-xl">{description}</p>
      </header>

      <Button onClick={onButtonPress}>{buttonTitle}</Button>
    </article>
  );
}
